import { ref } from 'vue';
// Cross-page handoff for "the user just changed a category — keep the row
// spinner on until the landing page's data reflects it". Set by
// TransactionDetailPage when a category change is applied; consumed by
// AccountPage / MoneyPage / SpendingAnalysisPage on mount via
// useTransactionUpdateHandoff.
export const pendingTransactionUpdateId = ref(null);
// One-shot flag set by TransactionDetailPage after a category write, signalling
// that the next spending-analysis fetch on whichever page mounts next should
// run with pollUntilChanged. Consumed atomically via consumePendingWriteRevalidate
// to avoid the read-then-clear footgun.
export const pendingWriteRevalidate = ref(false);
export function consumePendingWriteRevalidate() {
    const v = pendingWriteRevalidate.value;
    pendingWriteRevalidate.value = false;
    return v;
}
// TDP-side "category update is mid-flight" marker. Set when the user taps
// Update for a self-change (txn poll + SA pollUntilChanged in progress);
// cleared when SA's pollUntilChanged response lands (or the txn poll exhausts
// without a change). Lives in shared module state so it survives navigation
// away from TransactionDetailPage and back — letting TDP restore the disabled
// "Working...." lozenge and row spinners on remount while the polls (which
// run via setTimeout closures, not component-bound) finish in the background.
//
// `baselineHash` is the txn's server content hash captured *before* the write
// fired. Both the upfront poll and the on-remount repoll compare against this
// pre-write value, so a remount whose initial fetch already returns the new
// payload still detects the change instead of polling fruitlessly against a
// baseline that has already moved.
// `baselineFields` is a stringified snapshot of the txn's classification id +
// excludeFromAnalysis flag, captured at the same moment as `baselineHash`. It's
// the fallback comparator used by the txn poll when the server doesn't return
// an x-mgcache-md5 header (e.g. running against non-/Cached/ endpoints) so the
// poll can still detect when the write has landed.
export const inflightCategoryUpdate = ref(null);
export function txnFieldsKey(t) {
    return `${t?.effectiveClassification?.id ?? ''}|${t?.excludeFromAnalysis ? 1 : 0}`;
}
